import { supabase } from "@/integrations/supabase/client";

export interface ContactPayload {
  nombre: string;
  email: string;
  telefono?: string;
  mensaje: string;
  servicio?: string;
  type?: 'contact' | 'appointment';
}

export async function submitContactForm(data: ContactPayload): Promise<void> {
  const { data: result, error } = await supabase.functions.invoke('send-contact-email', {
    body: {
      name: data.nombre,
      email: data.email,
      phone: data.telefono,
      service_area: data.servicio || 'Consulta general',
      message: data.mensaje,
      type: data.type || 'contact',
    },
  });

  if (error || !result?.success) {
    throw new Error(result?.error || error?.message || 'Error al enviar formulario');
  }
}
